// extracted by mini-css-extract-plugin
module.exports = {"hover":"StreamPaymentsReviewStep_hover__z1QHP"};